import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { Observable } from 'rxjs';

import { SignedUrlObject } from '@shared/models';
import { BaseService } from '@shared/services/base.service';

import { CancelStoreStockRecall, CreateStoreStockRecall } from '../model/create-store-stock-recall.model';

@Injectable({
  providedIn: 'root'
})
export class CreateStoreStockRecallService extends BaseService {
  envService;
  headers: HttpHeaders;

  private readonly http = inject(HttpClient);
  protected readonly logger = inject(NGXLogger);

  constructor() {
    super();
    this.envService = this.env.services.stockStoreRecall;
    this.headers = new HttpHeaders(this.envService.headers);
  }

  createStoreStockRecall(payload: CreateStoreStockRecall): Observable<any> {
    const url = this.getFullUrl(this.envService.submit);
    return this.http.post<any>(url, payload, { headers: this.headers });
  }

  cancelStoreStockRecall(payload: CancelStoreStockRecall) {
    const url = this.getFullUrl(this.envService.cancel);
    return this.http.post(url, payload, {
      headers: this.loaderHeaders(),
      observe: 'body'
    });
  }

  draftStoreStockRecall(payload: CreateStoreStockRecall): Observable<any> {
    const url = this.getFullUrl(this.envService.save);
    return this.http.post<any>(url, payload, { headers: this.headers });
  }

  deleteDraftStoreStockRecall(id: string): Observable<any> {
    const url = this.getFullUrl(this.envService.delete + `/${id}`);
    return this.http.delete<any>(url, { headers: this.headers });
  }

  public getFileUrl(refId: string): Observable<SignedUrlObject> {
    const url = this.getFullUrl(this.envService.imageSignedUrl);
    return this.http.post<SignedUrlObject>(url, { refId }, { headers: this.headers });
  }

  importSubmitsStoreStockRecall(payload: File) {
    const url = this.getFullUrl(this.envService.import);
    let formData = new FormData();
    formData.append('file', payload, payload.name);

    this.headers.append('Content-Type', 'multipart/form-data');
    return this.http.post(url, formData, { headers: this.loaderHeaders() });
  }

  downloadFileTemplate() {
    const url = this.getFullUrl(this.envService.downloadTemplate);
    return this.http.get(url, { headers: this.loaderHeaders(), responseType: 'blob' });
  }
}
